import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type { ViewComponent } from "@frui.ts/views/dist";
import { Input } from "@frui.ts/bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import LicensePlateInput from "controls/licensePlateInput";
import DatePickerBox from "controls/datePickerBox";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import type CreateExemptionViewModel from "viewModels/callCenter/search/exemptions/createExemption/createExemptionViewModel";
import CountrySelect from "views/common/countrySelect";

const CreateExemptionFormSection: ViewComponent<CreateExemptionViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} target={vm.item.vehicle} property="countryId">
          <FormLabel>{vm.translateAttribute("licensePlate", "countryId")}</FormLabel>
          <CountrySelect vm={vm.countrySelectViewModel} allowEmpty={true} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item.vehicle} property="licensePlate">
          <FormLabel>{vm.translateAttribute("licensePlate", "licensePlate")}</FormLabel>
          <LicensePlateInput />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="validSinceDate">
          <FormLabel>{vm.translateAttribute("exemption", "validSinceDate")}</FormLabel>
          <DatePickerBox placeholder={vm.translateAttribute("exemption", "validSinceDate")} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item} property="validUntilDate">
          <FormLabel>{vm.translateAttribute("exemption", "validUntilDate")}</FormLabel>
          <DatePickerBox placeholder="" />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="exemptionReasonId">
          <FormLabel>{vm.translateAttribute("exemption", "exemptionReasonId")}</FormLabel>
          <AdvancedSelect
            className="autoHeight"
            items={vm.exemptionReasonOptions}
            formatOptionLabel={(data: any) => {
              return <span dangerouslySetInnerHTML={{ __html: data.label }} />;
            }}
            mode="key"
          />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm} property="officialRecordId">
          <FormLabel required={true}>{vm.translateAttribute("exemption", "officialRecordId")}</FormLabel>
          <Input errorMessage={vm.officialRecordIdError} />
        </FormGroup>
      </Form.Row>
    </>
  );
});

export default CreateExemptionFormSection;
